import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import './toggle.scss';


function Toggle(props) {
  const [isExpanded, setWhetherExpanded] = useState(false);

  function expandItem(_) {
    setWhetherExpanded(!isExpanded);
  };

  const options = {
    replace: (domNode) => {
      if (domNode.attribs && domNode.attribs.class === "remove") {
        return <></>;
      }
    },
  };

  return (
    <div className="toggle-container">
      <div onClick={expandItem} className="toggle-box">
        <p className="toggle-question">{props.question}</p>
        <span className="toggle-icon">
          <FontAwesomeIcon
            icon={faChevronCircleDown}
            size="1x"
          />
        </span>
      </div>
      <div className={`toggle-content ${!isExpanded ? 'hidden' : ''}`}>
        {props.children}
      </div>
    </div>
  );
}

export default Toggle;
